const SIZES = {
  lg: { script: "text-[3.7rem] leading-[1.25] sm:text-7xl lg:text-8xl", brand: "mb-1 text-[11px] sm:text-xs tracking-[0.5em]", artist: "mt-3 text-2xl" },
  md: { script: "text-5xl sm:text-6xl", brand: "text-[10px] tracking-[0.45em]", artist: "mt-2 text-xl" },
  sm: { script: "text-4xl", brand: "text-[9px] tracking-[0.4em]", artist: "mt-1 text-lg" },
};

export function TitleLockup({ size = "md", as: Tag = "h1", testid, artistTestid, center = false }) {
  const s = SIZES[size];
  return (
    <div className={center ? "flex flex-col items-center text-center" : "flex flex-col items-start"}>
      <Tag data-testid={testid} aria-label="Feeling Heart" className={`flex flex-col ${center ? "items-center" : "items-start"}`}>
        <span className={`font-script font-normal leading-[1.15] text-[#4A2D55] ${s.script}`}>Feeling Heart</span>
      </Tag>
      <p data-testid={artistTestid} className={`font-hand text-[#A0857A] ${s.artist}`}>
        an exhibition by Priyanka Jha
      </p>
    </div>
  );
}
